import { QueryClient } from "react-query";
import { DEFAULT_CACHE_TIME, DEFAULT_STALE_TIME } from "../utils/const";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: DEFAULT_STALE_TIME,
      cacheTime: DEFAULT_CACHE_TIME,
      refetchOnWindowFocus: false,
    },
  },
});
